import { CheckCircleIcon } from "components/Icons";
import { IMAGEN_PRODUCT_DEFAULT } from "tools/constants";
import { useTable } from "storev2/tableStore";

function ItemRow({ name, value }) {
  const isArray = Array.isArray(value);
  return (
    <div className="grid grid-cols-2 justify-items-start gap-x-4 mt-4 bg-[#ededf75F] rounded-2xl w-full p-4">
      <div className="font-bold flex space-x-2">
        <CheckCircleIcon className="w-5 h-5 fill-current text-[#1f2837]" />
        <span className="text-md text-[#1f2837] font-bold">{name}</span>
      </div>

      <div className="text-left text-[#626264] font-normal text-sm">
        {isArray ? (
          <ul className="list-disc list-inside space-y-1">
            {value.map((item, i) => (
              <li
                className="list-none p-0 m-0 grid grid-cols-3 gap-x-2"
                key={i}
              >
                <span>{item.size}</span>
                <span>→</span>
                <span>{item.qty}</span>
              </li>
            ))}
          </ul>
        ) : (
          value
        )}
      </div>
    </div>
  );
}

function ModalSIngleProduct(props) {
  const { record } = props;
  const { name, code, cost_price, images, quantity, sale_uom } = record;
  const _image = record?.["images."][0]?.image_url ?? IMAGEN_PRODUCT_DEFAULT;
  const { openModalTable } = useTable();

  function handleViewMore(e) {
    e.stopPropagation();
    openModalTable(SingleProduct, props, name);
  }

  function SingleProduct() {
    return (
      <div onClick={(e) => e.stopPropagation()}>
        <div className="flex relative pb-5 px-10">
          <div className="w-[45%] pr-10">
            <img
              src={_image}
              alt="product"
              className="w-full h-[443px] rounded-2xl object-cover sticky top-0 bg-[#ededf777]"
            />
          </div>

          <div className="w-[55%]">
            <div>
              <ItemRow name="Costo" value={cost_price} />
              <ItemRow name="Unidad de medida" value={sale_uom} />
              <ItemRow name="Cantidad" value={quantity} />
              <ItemRow name="Código" value={code} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <figure className="cursor-pointer" onClick={handleViewMore}>
      <img
        src={_image}
        className="size-[57px] rounded-md border border-gray-300 object-cover object-center bg-white mx-auto"
        alt="product"
      />
    </figure>
  );
}

export default ModalSIngleProduct;
